module.exports = '2.1.8';



//////////////////
// WEBPACK FOOTER
// ./~/graphlib/lib/version.js
// module id = 2016
// module chunks = 0